<template>
  <div>
    <Header :title="title" :showBack="true" :isFromDriver="isFromDriver"></Header>

    <div class="LineClassPicker">
      <!-- 线路信息 -->
      <div style="height: 2.7rem;">
        <van-cell style="height: 0.9rem;" icon="logistics" title="路线" :value="line.text" />
        <van-cell style="height: 0.9rem;" icon="clock-o" title="始发时间" :value="lineClassDay.ClassTime" />
        <van-cell style="height: 0.9rem;" icon="location-o" :value="node.NodeName">
          <div slot="title">
            站点
            <van-button size="mini" type="info" v-on:click="onUpdateNodeGisBtn"
              v-if="IsCanUpdateNodeGis">更新站点坐标</van-button>
          </div>
        </van-cell>
      </div>
      <van-button type="warning" block @click="printCheckList" v-if="IsShowPrintCheckList">打印结算单</van-button>
      <!-- 车辆司机信息 -->
      <div>
        <van-cell-group title="车辆司机信息">
          <!-- 车辆信息 -->
          <div class="vehicleDiv">
            <!-- 车辆基础信息块 -->
            <div class="info">
              <div class="vehicleno">
                车牌号码:
                <span class="cnospan" @click="goCheckVehicle">
                  {{ checkVehicle.VehicleNo }}
                </span>
              </div>
              <div class="vehicleBtn">
                <!-- <div class="signbtn">
                  <van-button
                    size="small "
                    style="color: white;"
                    :class="(nodelog && nodelog.SignInOperTime)?'btnColorGreen':'btnColorOrange'"
                    @click="onGetNodeGis"
                  >{{(nodelog && nodelog.SignInOperTime)?'已签到':'签到'}}</van-button>
                </div>-->
                <div class="checkRadio" v-if="nodelog && nodelog.SignInOperTime">
                  <van-icon name="checked" color="#07c160" />
                  {{
      nodelog.SignInType == 1 ? "车辆位置验证" : "现场车牌验证"
    }}
                  <p>
                    {{
        $moment(nodelog.SignInOperTime).format("YYYY-MM-DD HH:mm")
      }}
                  </p>
                </div>
                <div class="checkRadio" v-else>
                  <span style="font-size: 16px; color: red;">未签到</span>
                </div>
              </div>
            </div>
            <!-- 车辆图片块 -->
            <div class="img">
              <input type="file" ref="vehicleImginput" style="display: none;" v-on:change="changeImage()"
                accept="image/*" capture="camera" />
              <!-- 唤起摄像头安卓可能存在内存不足杀掉浏览器进程的问题 -->
              <van-uploader :after-read="afterReadImg" v-model="vehicleImg" :disabled="true" :max-count="1"
                upload-text="车牌照片" preview-size="2.7rem" style="margin: 10px 0px 10px 30px; display: none;"
                accept="image/*" capture="camera" />
              <van-image style="margin: 10px 0px 10px 1.2rem;" width="2.4rem" height="2.4rem"
                :src="nodelog && nodelog.SignInImg ? nodelog.SignInImg : ''" @click="imgView(nodelog.SignInImg)">
                <template v-slot:error>&nbsp;</template>
              </van-image>
            </div>
          </div>
          <div class="link-top"></div>
          <!-- 司机1信息 -->
          <div class="vehicleDiv" style="height: 2.6rem;">
            <!-- 司机基础信息块 -->
            <div class="dirverradio">
              <van-checkbox v-model="checkedDriver1" :disabled="nodelog &&
      (nodelog.StartCarTime != null ||
        (nodelog.StartCarTime == null &&
          nodelog.SignInOperTime == null))
      " style="margin-left: 0.8rem; margin-top: 0.6rem;"></van-checkbox>
              <div style="margin-left: 0.4rem;" v-show="checkedDriver1">
                已验证
              </div>
            </div>
            <div class="dirverinfo">
              <div style="
                  margin-top: 0.1rem;
                  border-bottom: 1px solid #acc0d8;
                  margin-left: 0.3rem;
                ">
                {{ checkVehicle.Driver1Name }}
              </div>
              <div style="
                  margin-top: 0.1rem;
                  border-bottom: 1px solid #acc0d8;
                  margin-left: 0.3rem;
                ">
                <a :href="'tel:' + checkVehicle.Driver1Tel" style="color: black;">{{ checkVehicle.Driver1Tel }}</a>
              </div>
              <div style="margin-top: 0.1rem; margin-left: 0.3rem;">
                从业资格证:
              </div>
              <div style="margin-left: 0.3rem;">
                {{ checkVehicle.Driver1IndustryCertNo }}
              </div>
            </div>
            <!-- 司机图片块 -->
            <div class="img">
              <img style="
                  margin: 0rem 0px 10px 1.2rem;
                  width: 2.3rem;
                  height: 2.3rem;
                " src="../../img/司机1.png" />
            </div>
          </div>
          <div class="link-top" v-if="checkVehicle.Driver2Tel"></div>
          <!-- 司机2信息 -->
          <div class="vehicleDiv" v-if="checkVehicle.Driver2Tel" style="height: 2.6rem;">
            <!-- 司机基础信息块 -->
            <div class="dirverradio">
              <van-checkbox v-model="checkedDriver2" :disabled="nodelog &&
      (nodelog.StartCarTime != null ||
        (nodelog.StartCarTime == null &&
          nodelog.SignInOperTime == null))
      " style="margin-left: 0.8rem; margin-top: 0.6rem;"></van-checkbox>
              <div style="margin-left: 0.4rem;" v-show="checkedDriver2">
                已验证
              </div>
            </div>
            <div class="dirverinfo">
              <div style="
                  margin-top: 0.1rem;
                  border-bottom: 1px solid #acc0d8;
                  margin-left: 0.3rem;
                ">
                {{ checkVehicle.Driver2Name }}
              </div>
              <div style="
                  margin-top: 0.1rem;
                  border-bottom: 1px solid #acc0d8;
                  margin-left: 0.3rem;
                ">
                <a :href="'tel:' + checkVehicle.Driver2Tel" style="color: black;">{{ checkVehicle.Driver2Tel }}</a>
              </div>
              <div style="margin-top: 0.1rem; margin-left: 0.3rem;">
                从业资格证:
              </div>
              <div style="margin-left: 0.3rem;">
                {{ checkVehicle.Driver2IndustryCertNo }}
              </div>
            </div>
            <!-- 司机图片块 -->
            <div class="img">
              <img style="
                  margin: 0rem 0px 10px 1.2rem;
                  width: 2.3rem;
                  height: 2.3rem;
                " src="../../img/司机1.png" />
            </div>
          </div>
        </van-cell-group>
      </div>

      <!-- 安检单信息 -->
      <div v-show="IsUploadCheck">
        <van-cell-group title="安检单信息">
          <van-cell title="安检情况" title-class="Title-CellClass" max-size>
            <van-uploader class="uploadBox" :after-read="onReadImg" accept="image/*" style="text-align: center;"
              multiple>
              <span>点击上传照片</span>
              <van-icon class="uploadIcon" name="photograph" style="margin-left: 0.12rem; top: 0.05rem;" />
            </van-uploader>
          </van-cell>
          <div style="text-align: center;">
            <img :src="CheckImage" style="width: 90%;" />
          </div>
        </van-cell-group>
      </div>

      <!-- 班次乘客信息 -->
      <div v-cloak v-if="ticketInfoList.length > 0">
        <van-cell-group title="乘客信息" style="font-size: 0.5rem; font-weight: 600; padding: 0.3rem;">
          <van-row>
            <van-col span="7">
              <span>已检: {{ ticketInfoList[0].CheckedTickets }}</span>
              <!-- <van-cell :value="'已检:'+ticketInfoList[0].CheckedTickets" /> -->
            </van-col>
            <van-col span="9">
              <span>含儿童: {{ ticketInfoList[0].CheckedChildren }}</span>
              <!-- <van-cell :value="'含儿童:'+ticketInfoList[0].CheckedChildren" /> -->
            </van-col>
            <van-col span="7">
              <span>未检: {{ ticketInfoList[0].NoCeckedCount }}</span>
              <!-- <van-cell :value="'未检:'+ticketInfoList[0].NoCeckedCount" /> -->
            </van-col>
          </van-row>
          <van-row style="margin-top: 0.5rem;">
            <van-col span="12">
              <span>本站上车人数:</span>
              <input type="number" v-model="passengerCount" style="
                  width: 20%;
                  float: right;
                  color: blue;
                  border-width: 3px;
                " />
              <!-- <van-field label="本站上车人数:" v-model="passengerCount" input-align="left" type="number" /> -->
            </van-col>
            <van-col span="12">
              <span style="float: left;">随车人员:</span>
              <!-- <van-stepper
                v-model="staffCount"
                min="0"
                integer
                input-width="25px"
                button-size="25px"
                style="float:right;color:blue"
              />-->
              <button class="van-stepper__minus" style="width: 0.7rem; height: 0.7rem; float: left;"
                @click="stepBtnDel"></button>
              <input type="number" v-model="staffCount"
                style="width: 15%; float: left; color: blue; border-width: 2px;" />
              <button @click="stepBtnAdd" class="van-stepper__plus"
                style="width: 0.7rem; height: 0.7rem; float: left;"></button>
            </van-col>
          </van-row>
        </van-cell-group>

        <!-- 发车取消按钮 -->
        <van-row type="flex" justify="space-around" style="margin-top: 0.5rem;"
          v-if="!nodelog || (nodelog && !nodelog.StartCarTime)">
          <van-col span="6">
            <van-button block type="info" :style="{ backgroundColor: $store.state.baseColor }"
              @click="onReportBtnClick">发车</van-button>
          </van-col>
          <van-col span="6">
            <van-button block type="default" @click="goHome">取消</van-button>
          </van-col>
        </van-row>
        <!-- 修改 取消发车 按钮 -->
        <van-row type="flex" justify="space-around" style="margin-top: 10px;" v-else>
          <van-col span="6">
            <van-button block type="info" :style="{ backgroundColor: $store.state.baseColor }"
              @click="onUpdateRecord">修改</van-button>
          </van-col>
          <van-col span="7">
            <van-button block type="info" :style="{ backgroundColor: $store.state.baseColor }"
              @click="cancelSendCar">取消发车</van-button>
          </van-col>
          <van-col span="6">
            <van-button block type="default" @click="goHome">返回</van-button>
          </van-col>
        </van-row>
      </div>
    </div>

    <div class="footer"></div>

    <van-dialog v-model="showActionDialog" show-cancel-button cancel-button-text="退出" @cancel="showActionDialog = false"
      @confirm="onClickUploadImg">
      <div style="position: relative; top: 10px;">
        <van-icon name="warning" color="#FF9900" size="2rem" />
        <div style="
            width: 60%;
            float: right;
            position: relative;
            top: 10px;
            right: 10px;
          ">
          车辆位置验证不通过,进入现场车牌验证模式
        </div>
      </div>
      <div style="
          width: 84%;
          height: 92px;
          left: 8%;
          position: relative;
          top: 19px;
        ">
        按确定后将摄像头对准车辆车牌,注意:
        <span style="color: #ff9900;">请关闭闪光灯!</span>
      </div>
    </van-dialog>

    <div id="canvasImgDiv" ref="canvasImgDiv">
      <canvas id="canvasImg"></canvas>
    </div>
    <!-- <div id="map-container" style="display:none"></div> -->
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header/Header.vue";
// import mapUtil from "@/js/map.js";
import { ImagePreview } from "vant";

import AMapLoader from '@amap/amap-jsapi-loader';

export default {
  components: {
    Header,
  },
  data() {
    return {
      isWx: false, //是否微信环境
      title: "签到发车", //页面标题
      line: window.localStorage.getItem("line")
        ? JSON.parse(window.localStorage.getItem("line"))
        : JSON.parse(window.localStorage.getItem("lineClassDay")).LineName, //选择的线路
      lineClassDay: JSON.parse(window.localStorage.getItem("lineClassDay")), //选择的班次
      node: JSON.parse(window.localStorage.getItem("lineClassDayStratNode")), //选择的站点
      checkVehicle: JSON.parse(window.localStorage.getItem("checkVehicle")), //选择的车辆
      ValuePeople: parseInt(window.localStorage.getItem("ValuePeople")), //站点已检未上车人数
      sendPeople: 0, //站点已发送人员
      isCanBack: this.$route.query.isCanBack == "1", //是否允许返回选择车辆
      classLog: [], //班次发车记录
      vehicleList: [], //车辆集合
      vehicleImg: [], //车辆显示图片
      nodelog: null, //站点车辆签到发车记录
      vehicleNoimgBase64: null, //车辆Base64图片
      OCRvehicleNo: null, //识别的车牌号
      phoneGPS: null, //手持机定位
      nodeGis: null, //站点坐标
      vehicleGPS: null, //车辆定位
      updateNodeGis: false, //是否更新站点坐标
      checkedDriver1: false, //校验司机1信息
      checkedDriver2: false, //校验司机2信息
      showActionDialog: false, //提示使用现场验证模式
      map: null, //高德地图
      ticketInfoList: [], //站点检票信息
      GpsVerificationType: "NodeGPS,VehicleGPS,MobileGPS",
      passengerCount: 0, //车上人数
      staffCount: 0, //随车人数
      isFromDriver: this.$route.query.isFromDriver == "1",
      IsCanUpdateNodeGis: this.$utils.getSysParams("IsCanUpdateNodeGis") == "1",
      IsShowPrintCheckList:
        this.$utils.getSysParams("IsShowPrintCheckList") == "1", //是否显示打印结算清单
      gpsTimer: null, //获取定位倒计时
      CheckImage: "", //安检图片
      IsUploadCheck: this.$utils.getSysParams("IsUploadCheck") === "1", //新签到模式中是否要求上传安检单
    };
  },
  watch: {},
  methods: {
    getTrimStr(str) {
      let maxLength = str == "免" ? 4 : 6;
      let trim = "";
      for (let index = 0; index < maxLength - str.length; index++) {
        trim += " ";
      }
      return trim;
    },

    //安检情况图片上传
    onReadImg(file) {
      // 大于1.5MB的jpeg和png图片都缩小像素上传
      if (/\/(?:jpeg|png)/i.test(file.file.type) && file.file.size > 1500000) {
        // 创建Canvas对象(画布)
        let canvas = document.createElement("canvas");
        // 获取对应的CanvasRenderingContext2D对象(画笔)
        let context = canvas.getContext("2d");
        // 创建新的图片对象
        let img = new Image();
        // 指定图片的DataURL(图片的base64编码数据)
        img.src = file.content;
        // 监听浏览器加载图片完成，然后进行进行绘制
        img.onload = () => {
          // 指定canvas画布大小，该大小为最后生成图片的大小
          canvas.width = 400;
          canvas.height = 300;
          /* drawImage画布绘制的方法。(0,0)表示以Canvas画布左上角为起点，400，300是将图片按给定的像素进行缩小。
        如果不指定缩小的像素图片将以图片原始大小进行绘制，图片像素如果大于画布将会从左上角开始按画布大小部分绘制图片，最后的图片就是张局部图。*/

          context.drawImage(img, 0, 0, 400, 300);
          // 将绘制完成的图片重新转化为base64编码，file.file.type为图片类型，0.92为默认压缩质量
          file.content = canvas.toDataURL(file.file.type, 0.92);
          // 最后将base64编码的图片保存，留待上传。
          this.CheckImage = file.content;
        };
      } else {
        // 不做处理的jpg和png直接保存
        this.CheckImage = file.content;
      }
    },

    //打印结算清单
    printCheckList() {
      //连接打印
      if (window.framework) {
        //判断方法是否存在 // 连接打印机
        if (window.framework.isReadPrint) {
          window.framework.isReadPrint(true);
        }

        let params = {
          LineClassDayGID: this.lineClassDay.GID,
          StartNodeGID: this.node.NodeGID,
        };
        this.$http
          .post(
            this.$api.onTicketCheckDetailPrintQuery,
            this.$qs.stringify(params)
          )
          .then((res) => {
            if (res.success) {
              let info = res.data;
              let checkInfo = res.data.NodeTicketData;
              let str = "";
              checkInfo.forEach((item) => {
                item.FullCount = item.FullCount
                  ? item.FullCount.toString()
                  : "0";
                item.HalfCount = item.HalfCount
                  ? item.HalfCount.toString()
                  : "0";
                item.ChildCount = item.ChildCount
                  ? item.ChildCount.toString()
                  : "0";
                item.OtherCount = item.OtherCount
                  ? item.OtherCount.toString()
                  : "0";
                item.FullPrice = item.FullPrice
                  ? item.FullPrice.toString()
                  : "0";
                item.HalfPrice = item.HalfPrice
                  ? item.HalfPrice.toString()
                  : "0";
                item.OtherPrice = item.OtherPrice
                  ? item.OtherPrice.toString()
                  : "0";
                item.TotalCount = item.TotalCount
                  ? item.TotalCount.toString()
                  : "0";
                item.TotalMoney = item.TotalMoney
                  ? item.TotalMoney.toString()
                  : "0";
                str +=
                  "\n-------------------------------\n" +
                  item.NodeName +
                  ":\n数量:" +
                  item.FullCount +
                  this.getTrimStr(item.FullCount) +
                  item.HalfCount +
                  this.getTrimStr(item.HalfCount) +
                  item.OtherCount +
                  this.getTrimStr(item.OtherCount) +
                  item.ChildCount +
                  this.getTrimStr("免") +
                  item.TotalCount +
                  "\n票价:" +
                  item.FullPrice +
                  this.getTrimStr(item.FullPrice) +
                  item.HalfPrice +
                  this.getTrimStr(item.HalfPrice) +
                  item.OtherPrice +
                  this.getTrimStr(item.OtherPrice) +
                  "0" +
                  this.getTrimStr("免") +
                  item.TotalMoney;
              });
              let classdatetime =
                this.$moment(info.ClassDate).format("YYYY-MM-DD") +
                "  " +
                info.ClassTime;
              classdatetime = this.$moment(classdatetime).format(
                "YYYY-MM-DD HH:mm"
              );
              let jsonArray = [
                {
                  type: 1,
                  size: 2,
                  data: "  检票结算清单\n",
                },
                {
                  type: 1,
                  data:
                    "\n检票站点:" +
                    info.StartNodeName +
                    "\n打印时间:" +
                    this.$moment().format("YYYY-MM-DD HH:mm") +
                    "\n线路名称:" +
                    this.line.text +
                    "\n班次号码:" +
                    info.ClassCode +
                    "\n班次时间:" +
                    classdatetime +
                    "\n车牌号码:" +
                    info.VehicleNoList +
                    "\n司机姓名:" +
                    info.DriverNameList +
                    "\n-------------------------------\n    全票  半票  其它  免  合计" +
                    str +
                    "\n-------------------------------\n签名:\n\n\n\n------------------------------\n\n",
                },
              ];

              let printStr = jsonArray[0].data + "" + jsonArray[1].data;
              if (window.framework.jsPrintJsonData) {
                window.framework.jsPrintJsonData(JSON.stringify(jsonArray));
              } else {
                window.framework.jsPrintText(printStr);
              }
            }
          });
      } else {
        this.$toast("开启打印服务失败");
      }
    },

    //签到失败保存记录
    onSaveonSignInErrorRecord(type, img, remark, msgtype) {
      var that = this;
      let params = {
        _JsonText: JSON.stringify({
          LineClassDayGID: this.lineClassDay.GID,
          StartNodeGID: this.node.NodeGID,
          VehicleGID: this.checkVehicle.VehicleGID,
          SignInType: type,
          SignInImg: img,
          PhoneGPS: this.phoneGPS.longitude + "," + this.phoneGPS.latitude,
          VehilceGPS: this.vehicleGPS
            ? this.vehicleGPS.lon + "," + this.vehicleGPS.lat
            : null,
          NodeGPS: this.nodeGis.lng + "," + this.nodeGis.lat,
          Remark: remark,
          ModifyGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID,
          ModifyCode: JSON.parse(window.localStorage.getItem("adminInfo"))
            .UserCode,
          ModifyName: JSON.parse(window.localStorage.getItem("adminInfo"))
            .UserName,
        }),
      };
      this.$http
        .post(
          this.$api.onLineClassDaySignInErrorRecordSave,
          this.$qs.stringify(params)
        )
        .then((res) => {
          if (res.success) {
            //后台静默保存
            switch (msgtype) {
              case 1:
                that.$dialog.alert({ message: "您当前距离站点超出2千米!" });
                break;
              case 2:
                that.showActionDialog = true;
                break;
              case 3:
                that.$dialog
                  .alert({
                    message:
                      "识别车牌号为:" +
                      this.OCRvehicleNo +
                      ",与所派车辆:" +
                      this.checkVehicle.VehicleNo +
                      " 不一致,签到失败",
                  })
                  .then(() => {
                    // if (
                    //   location.hostname == "192.168.137.1" ||
                    //   location.hostname == "test.hd.class.busboss.cn"
                    // ) {
                    //   this.vehicleNoimgBase64 = postParm.imgBase64;
                    //   this.onSaveSignInLog(2, 1);
                    //   return;
                    // }
                    that.vehicleImg = [];
                  });
                break;
              case 4:
                that.vehicleImg = [];
                break;
            }
          }
        });
    },
    //更新站点坐标
    onUpdateNodeGisBtn() {
      //先获取当前定位
      this.updateNodeGis = true;
      this.getPhoneGPS();
    },
    //更新站点信息请求
    updateNodeInfo(position) {
      console.log("进入更新站点方法");

      var that = this;
      this.updateNodeGis = false;
      //调用高德API获取当前坐标的省市区
      // eslint-disable-next-line
      AMap.plugin("AMap.Geocoder", function () {
        // eslint-disable-next-line
        var geocoder = new AMap.Geocoder({});
        var lnglat = [position.coords.longitude, position.coords.latitude];
        geocoder.getAddress(lnglat, function (status, result) {
          if (status === "complete" && result.info === "OK") {
            // result为对应的地理位置详细信息
            console.log(result);
            //获取站点基础信息
            let nodeparams = {
              GID: that.node.NodeGID,
            };
            that.$http
              .post(that.$api.onNodeQuery, that.$qs.stringify(nodeparams))
              .then((res) => {
                if (res.success) {
                  //查询成功
                  let reviseJson = {
                    Old: {
                      省份名称: res.data[0].ProvinceName,
                      城市名称: res.data[0].CityName,
                      区县名称: res.data[0].DistrictName,
                      街道名称: res.data[0].CountrySide,
                      小区名称: res.data[0].Village,
                      具体地址: res.data[0].Addr,
                      坐标地址: res.data[0].Geocoder,
                    },
                    New: {
                      省份名称: result.regeocode.addressComponent.province,
                      城市名称: result.regeocode.addressComponent.city,
                      区县名称: result.regeocode.addressComponent.district,
                      街道名称: result.regeocode.addressComponent.street,
                      小区名称: result.regeocode.addressComponent.township,
                      具体地址: result.regeocode.formattedAddress,
                      坐标地址: lnglat.toString(),
                    },
                  };
                  that.$dialog
                    .confirm({
                      title: "操作确认",
                      message:
                        "确定要将站点位置:\n" +
                        res.data[0].Addr +
                        "(" +
                        res.data[0].Geocoder +
                        ")\n修改至:\n" +
                        result.regeocode.formattedAddress +
                        "(" +
                        lnglat.toString() +
                        ")吗？",
                    })
                    .then(() => {
                      let params = {
                        _JsonText: JSON.stringify({
                          NodeGID: that.node.NodeGID,
                          ReviseJson: reviseJson,
                          ModifyGID: JSON.parse(
                            window.localStorage.getItem("adminInfo")
                          ).GID,
                          ModifyCode: JSON.parse(
                            window.localStorage.getItem("adminInfo")
                          ).UserCode,
                          ModifyName: JSON.parse(
                            window.localStorage.getItem("adminInfo")
                          ).UserName,
                        }),
                      };
                      that.$http
                        .post(
                          that.$api.onNodeReviseSave,
                          that.$qs.stringify(params)
                        )
                        .then((res) => {
                          if (res.success) {
                            //修改成功
                            that.$toast("更新成功!");
                            that.node.Geocoder = res.data.Geocoder;
                            that.node.Addr = res.data.Addr;
                            window.localStorage.setItem(
                              "lineClassDayStratNode",
                              that.node
                            );
                          }
                        });
                    })
                    .catch(() => {
                      // on cancel
                      return;
                    });
                }
              });
          } else {
            //获取失败
            that.$dialog.alert({ message: "获取地理位置信息失败！" });
          }
        });
      });
    },
    stepBtnDel() {
      if (this.staffCount <= 0) {
        this.staffCount = 0;
        return;
      }
      this.staffCount -= 1;
    },
    stepBtnAdd() {
      this.staffCount += 1;
    },
    //图片预览
    imgView(img) {
      let imgs = [];
      if (img) {
        imgs.push(img);
      }
      if (imgs.length <= 0) {
        return;
      }
      ImagePreview({
        images: imgs,
        onClose() {
          // do something
        },
      });
    },
    // 取消发车提示
    cancelSendCar() {
      this.$dialog
        .confirm({
          title: "操作确认",
          message:
            "确定要取消车辆:" + this.checkVehicle.VehicleNo + "的发车吗？",
        })
        .then(() => {
          this.confirmCancelSendCar();
        })
        .catch(() => {
          // on cancel
        });
    },
    // 确定取消发车
    confirmCancelSendCar() {
      let params = {
        LineClassDayGID: this.lineClassDay.GID,
        StartNodeGID: this.node.NodeGID,
        VehicleGID: this.checkVehicle.VehicleGID,
      };
      this.$http
        .post(
          this.$api.onLineClassDayDepartureRecordDel,
          this.$qs.stringify(params)
        )
        .then((res) => {
          if (res.success) {
            //取消发车成功,返回首页
            this.$toast("取消发车成功");
            this.goHome();
          }
        });
    },
    //更新发车信息
    onUpdateRecord() {
      //判断是否修改
      if (!this.nodelog) {
        return;
      }
      if (
        this.nodelog.PassengerCount == this.passengerCount &&
        this.nodelog.StaffCount == this.staffCount
      ) {
        this.$toast.fail("未修改数据");
        return;
      } else {
        this.$dialog
          .confirm({
            message:
              "确定要将站点上车人数:" +
              this.nodelog.PassengerCount +
              " 随车工作人员:" +
              this.nodelog.StaffCount +
              "修改为  站点上车人数:" +
              this.passengerCount +
              " 随车工作人员:" +
              this.staffCount +
              "?",
          })
          .then(() => {
            //修改站点上车人数 做数据校验
            this.onBeforeContractReport(true, true);
          })
          .catch(() => { });
      }
    },
    //报备
    onContractReport() {
      //报备
      let params = {
        LineClassDayGID: this.lineClassDay.GID,
        ModifyGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID,
        ModifyCode: JSON.parse(window.localStorage.getItem("adminInfo"))
          .UserCode,
        ModifyName: JSON.parse(window.localStorage.getItem("adminInfo"))
          .UserName,
        LineDayClassStationGID: this.node.NodeGID,
        StaffCount: this.staffCount,
        VehicleGIDList: this.checkVehicle.VehicleGID,
        CustomMadeLevel: this.line.lineInfo.CustomMadeLevel,
      };

      if (window._exceptionlessClient) {
        window._exceptionlessClient
          .createFeatureUsage("发车")
          .setProperty("recordData", params)
          .submit();
      }
      this.$http
        .post(this.$api.onContractReport, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            //报备成功 保存发车记录
            //this.onSaveSignInLog(0, isUpdate ? 3 : 2);
          }
          if (this.isFromDriver) {
            this.$router.go(-1);
          }
        });
    },
    //报备前校验数据
    onBeforeContractReport(isUpdate, isReport) {
      let count = 0;
      this.ValuePeople =
        this.ticketInfoList[0].CheckedTickets - this.sendPeople;
      this.passengerCount = parseInt(this.passengerCount);
      this.classLog.forEach((item) => {
        if (!item.PassengerCount) {
          item.PassengerCount = 0;
        }
        count += parseInt(item.PassengerCount);
      });
      if (this.nodelog) {
        this.nodelog.PassengerCount = parseInt(this.nodelog.PassengerCount);
      }
      if (isUpdate) {
        count -= this.nodelog.PassengerCount;
        this.ValuePeople += this.nodelog.PassengerCount;
      }
      //1.车辆荷载人数大于已检人数+已有人数
      if (this.checkVehicle.PassengerSeatCount < this.passengerCount + count) {
        this.$toast.fail("车上人数大于核载人数，不能超载!");
        return;
      }

      //2.输入人数大于于该站点已检未上车人数
      if (this.passengerCount > this.ValuePeople) {
        this.$toast.fail(
          "站点上车人数:" +
          this.passengerCount +
          ",大于站点已检未上车人数:" +
          this.ValuePeople +
          "。请检查是否有未检票人上车!"
        );
        return;
      }
      //3.输入人数小于该站点已检未上车人数
      if (this.passengerCount < this.ValuePeople) {
        this.$dialog
          .confirm({
            message:
              "站点车上人数:" +
              this.passengerCount +
              ",小于站点已检未上车人数:" +
              this.ValuePeople +
              "。可能有已检票人未上车,是否继续发车?",
          })
          .then(() => {
            //确认修改 更新发车记录 调用合同更新 重新报备
            if (!isUpdate && isReport) {
              this.onGetNodeGis();
            } else if (!isReport) {
              this.onSaveSignInLog(0, 1);
            } else {
              this.onSaveSignInLog(0, 2);
            }
            return;
          })
          .catch(() => {
            return;
          });
      } else {
        //人数相等的情况
        if (!isUpdate && isReport) {
          this.onGetNodeGis();
        } else if (!isReport) {
          this.onSaveSignInLog(0, 1);
        } else {
          this.onSaveSignInLog(0, 2);
        }
      }
    },
    //发车操作
    onReportBtnClick() {
      //判断是否校验司机信息
      if (
        !this.checkedDriver1 ||
        (this.checkVehicle.Driver2Tel && !this.checkedDriver2)
      ) {
        this.$toast.fail("请校验司机信息");
        return;
      }

      let flag =
        [3].indexOf(parseInt(this.line.lineInfo.CustomMadeLevel)) !== -1;

      if (this.passengerCount <= 0) {
        this.$dialog
          .confirm({
            message: "站点上车人数为0,是否继续发车?",
          })
          .then(() => {
            //判断是否存在检票人数 存在检票人数也进行报备ClassCheckedTickets
            //console.log(this.$utils.getSysParams("ReportSaleOrCheck"));
            this.onBeforeContractReport(
              false,
              (this.ticketInfoList[0].ClassCheckedTickets > 0 ||
                this.lineClassDay.HandSellCount > 0) &&
              !flag
            );
            return;
          })
          .catch(() => {
            return;
          });
      } else {
        this.onBeforeContractReport(false, !flag);
      }
    },
    //返回主页
    goHome() {
      if (this.isFromDriver) {
        this.$router.go(-1);
      } else {
        this.$router.push({
          path: "LineClassDay",
        });
      }
    },
    //上传图片
    changeImage() {
      // 上传图片事件
      var that = this;
      let file = this.$refs.vehicleImginput.files[0];
      let reader = new FileReader();
      reader.onload = function () {
        let newfile = {
          file: file,
          content: this.result,
        };
        //console.log(newfile);
        that.afterReadImg(newfile);
      };
      reader.readAsDataURL(file);
    },
    //激活上传图片功能
    onClickUploadImg() {
      this.$refs.vehicleImginput.dispatchEvent(new MouseEvent("click"));
      //debugger
    },
    //检查坐标
    checkPhoneGPS(position) {
      this.phoneGPS = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      };
      console.log(position);
      //alert(position.coords.latitude + "," + position.coords.longitude);
      if (this.updateNodeGis) {
        this.updateNodeInfo(position);
        return;
      }
      let long = this.getFlatternDistance(
        this.phoneGPS.latitude,
        this.phoneGPS.longitude,
        this.nodeGis.lat,
        this.nodeGis.lng
      );
      console.log(long);
      //林和C 113.324285,23.140844   23.0812,113.2571
      if (
        long >= 2000 &&
        this.GpsVerificationType.indexOf("NodeGPS") > -1 &&
        this.GpsVerificationType.indexOf("MobileGPS") > -1
      ) {
        this.onSaveonSignInErrorRecord(
          1,
          null,
          "当前用户距离站点距离超过2千米,定位差距为" + long + "米",
          1
        );
        return;
      }
      //3.获取车辆定位
      this.onConwinVehicleQuery(this.checkVehicle);
    },
    //获取移动端定位成功
    onGetGPSSuccess(position) {
      this.endTimer();
      var that = this;
      var gps = [position.coords.longitude, position.coords.latitude];
      //如果是手机获取 需要转码
      if (!window.framework && position.getType != "wx") {
        this.$toast.loading({
          message: "获取定位成功，转码中...",
          forbidClick: true,
        });
        // eslint-disable-next-line
        AMap.convertFrom(gps, "gps", function (status, result) {
          if (result.info === "ok") {
            that.$toast.clear();
            let positions = {
              coords: {
                latitude: result.locations[0].lat,
                longitude: result.locations[0].lng,
              },
            };
            console.log("转码成功:" + JSON.stringify(positions));
            that.checkPhoneGPS(positions);
            //that.updateNodeInfo(positions);
            //return positions;
          } else {
            that.$toast("获取定位成功，转码失败");
            return;
          }
        });
        return;
      } else {
        that.checkPhoneGPS(position);
        //that.updateNodeInfo(position);
      }
    },
    //结束倒计时提示
    endTimer() {
      clearInterval(this.gpsTimer);
      // 手动清除 Toast
      this.$toast.clear();
    },
    //定位数据获取失败响应
    onGetGPSError(error) {
      this.endTimer();
      switch (error.code) {
        case error.PERMISSION_DENIED:
          alert("您拒绝对获取地理位置的请求");
          break;
        case error.POSITION_UNAVAILABLE:
          alert("位置信息是不可用的");
          break;
        case error.TIMEOUT:
          alert("请求您的地理位置超时");
          break;
        case error.UNKNOWN_ERROR:
          alert("未知错误");
          break;
        default:
          alert("获取设备定位失败");
          break;
      }
      //测试 直接当前定位为1918产业园
      if (
        location.hostname == "localhost" ||
        location.hostname == "192.168.137.1" ||
        location.hostname == "test.hd.class.busboss.cn"
      ) {
        let position = {
          coords: { latitude: this.nodeGis.lat, longitude: this.nodeGis.lng },
        };
        this.onGetGPSSuccess(position);
      }
    },
    //获取手持机定位
    getPhoneGPS() {
      this.phoneGPS = null;

      //线路设置不校验设备定位，不调用手持机定位获取
      if (this.GpsVerificationType.indexOf("MobileGPS") == -1) {
        let position = {
          coords: {
            latitude: this.node.Geocoder.split(",")[1],
            longitude: this.node.Geocoder.split(",")[0],
          },
        };
        this.onGetGPSSuccess(position);
        return;
      }

      //获取定位异常 直接返回站点坐标 2020-03-21 09:04:24
      // let position = {
      //   coords: {
      //     latitude: this.node.Geocoder.split(',')[1],
      //     longitude: this.node.Geocoder.split(',')[0]
      //   }
      // }
      // this.onGetGPSSuccess(position)

      //添加获取定位提示
      const toast = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "正在获取当前位置，倒计时 30 秒",
      });

      let second = 30;
      this.gpsTimer = setInterval(() => {
        second--;
        if (second >= 0) {
          toast.message = `正在获取当前位置，倒计时 ${second} 秒`;
        } else {
          this.endTimer();
          alert("获取当前位置超时，请移动到开阔地带后重试");
          return;
        }

        //如在10秒内则继续等待定位返回
      }, 1000);
      //手持机定位
      if (window.framework) {
        // 请求机器定位
        window.framework.jsGeolocation();
      } else {
        var that = this;
        if (this.$utils.getIsWxClient()) {
          wx.ready(function () {
            wx.getLocation({
              type: "gcj02", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
              success: function (res) {
                // var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                // var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                // var speed = res.speed; // 速度，以米/每秒计
                // var accuracy = res.accuracy; // 位置精度
                let position = {
                  coords: {
                    latitude: res.latitude,
                    longitude: res.longitude,
                  },
                  getType: "wx",
                };
                that.onGetGPSSuccess(position);
              },
              fail: () => {
                this.getCurrentPosition();
              },
            });
          });
        } else {
          this.getCurrentPosition();
        }
      }
    },
    //网页获取定位
    getCurrentPosition() {
      //非手持机 调用网页端获取机器定位
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          this.onGetGPSSuccess,
          this.onGetGPSError,
          {
            enableHighAcuracy: true, //位置是否精确获取
            timeout: 10000, //获取位置允许的最长时间
            //maximumAge: 1000, //多久更新获取一次位置
          }
        );
      } else {
        this.endTimer();
        alert("您的浏览器不支持获取地理位置服务");
      }
    },
    //车辆资质定位查询
    onConwinVehicleQuery(Vehicle) {
      if (this.GpsVerificationType.indexOf("VehicleGPS") == -1) {
        this.onSignInVheicle();
        return;
      }
      let params = {
        VehicleGID: Vehicle.VehicleGID,
        VehicleNo: Vehicle.VehicleNo,
        VehicleNoColor: Vehicle.CodeName,
        GPSTypeCode: Vehicle.VehicleGPSCode,
        QueryTypeList: "GPS",
      };
      this.vehicleGPS = null;
      this.$http
        .post(this.$api.onConwinVehicleQuery, this.$qs.stringify(params), {
          timeout: 15000,
        }) //15000 超时时间15s
        .then((res) => {
          if (res.success) {
            if (res.data.GPSAPIIsError === "1") {
              this.onSaveonSignInErrorRecord(
                1,
                null,
                "GPS接口异常参数开启,获取车辆GPS位置失败",
                2
              );
              return;
            }
            //GPS接口返回失败
            if (!res.data.GPS.success || !res.data.GPS.data) {
              //this.$toast.fail("GPS接口异常,查询失败");
              this.onSaveonSignInErrorRecord(
                1,
                null,
                "GPS接口异常,未获取到车辆GPS位置",
                2
              );
            } else {
              this.vehicleGPS = {
                lat: res.data.GPS.data.Lat,
                lon: res.data.GPS.data.Lon,
              };
              Vehicle.NowGPS =
                res.data.GPS.data.Lat + "," + res.data.GPS.data.Lon;
              this.onSignInVheicle(1);
            }
            //GPS签到 测试 正式需要注释
            // if (
            //   location.hostname == "192.168.137.1" ||
            //   location.hostname == "test.hd.class.busboss.cn"
            // ) {
            //   this.vehicleGPS = {
            //     lat: 23.0812,
            //     lon: 113.2571
            //   };
            // }
          } else {
            this.onSaveonSignInErrorRecord(
              1,
              null,
              "接口异常,未获取到车辆信息",
              2
            );
            return;
          }
        })
        .catch((err) => {
          //获取失败
          console.log(err);
          this.$dialog.alert({ message: "获取车辆GPS位置超时！" });
          this.onSaveonSignInErrorRecord(1, null, "获取车辆GPS位置超时！", 2);
          return;
        });
    },
    /*计算两经纬度点之间的距离(单位：米)*/
    getFlatternDistance: function (lat1, lng1, lat2, lng2) {
      /* @param lng1	经度1
       * @param lat1	纬度1
       * @param lng2	经度2
       * @param lat2	纬度2
       * @return 距离（米）
       * */
      var radLat1 = (lat1 * Math.PI) / 180.0;
      var radLat2 = (lat2 * Math.PI) / 180.0;
      var a = radLat1 - radLat2;
      var b = (lng1 * Math.PI) / 180.0 - (lng2 * Math.PI) / 180.0;
      var s =
        2 *
        Math.asin(
          Math.sqrt(
            Math.pow(Math.sin(a / 2), 2) +
            Math.cos(radLat1) *
            Math.cos(radLat2) *
            Math.pow(Math.sin(b / 2), 2)
          )
        );
      s = s * 6378.137;
      s = Math.round(s * 10000) / 10;
      return s;
    },
    //取得站点坐标
    onGetNodeGis() {
      //判断是否已经签到
      // if (this.nodelog && this.nodelog.SignInOperTime) {
      //   this.$toast("车辆已签到");
      //   return;
      // }
      //1.获取站点坐标
      this.nodeGis = {
        lat: this.node.Geocoder.split(",")[1],
        lng: this.node.Geocoder.split(",")[0],
      };
      // if (
      //   location.hostname == "192.168.137.1" ||
      //   location.hostname == "test.hd.class.busboss.cn"
      // ) {
      //   this.nodeGis = {
      //     lat: 23.0812,
      //     lng: 113.2571
      //   };
      // }
      if (!this.nodeGis.lat || !this.nodeGis.lng) {
        this.$toast.fail("未设置站点坐标");
        return;
      }
      //2.获取手持机定位
      this.getPhoneGPS();
    },
    //比对GPS位置 车辆签到
    onSignInVheicle(isGPS) {
      if (isGPS) {
        //判断车辆GPS距离站点小于1KM
        if (!this.vehicleGPS.lat || !this.vehicleGPS.lon) {
          this.onSaveonSignInErrorRecord(1, null, "未获取到车辆GPS位置", 2);
          return;
        }
        //判断是校验哪几个坐标位置
        let long = 0;
        if (
          this.GpsVerificationType.indexOf("MobileGPS") > -1 &&
          this.GpsVerificationType.indexOf("VehicleGPS") > -1
        ) {
          long = this.getFlatternDistance(
            this.vehicleGPS.lat,
            this.vehicleGPS.lon,
            this.phoneGPS.latitude,
            this.phoneGPS.longitude
          );
        }
        if (
          this.GpsVerificationType.indexOf("NodeGPS") > -1 &&
          this.GpsVerificationType.indexOf("VehicleGPS") > -1
        ) {
          long = this.getFlatternDistance(
            this.vehicleGPS.lat,
            this.vehicleGPS.lon,
            this.nodeGis.lat,
            this.nodeGis.lng
          );
        }
        if (long >= 2000) {
          this.onSaveonSignInErrorRecord(
            1,
            null,
            "车辆距离超过2千米,定位差距为" + long + "米",
            2
          );
          return;
        }
        //符合GPS签到条件 签到车辆
        this.onSaveSignInLog(1, 1);
      } else {
        this.onSaveSignInLog(1, 1);
      }
    },
    //前往选择车辆
    goCheckVehicle() {
      if (!this.isCanBack) {
        return;
      } else {
        this.$router.push({
          path: "SelectVehicle",
        });
      }
    },
    //保存签到 发车 记录
    onSaveSignInLog(SignInType, OperType) {
      let VehicleInfo = {
        VehicleGID: this.checkVehicle.VehicleGID,
        VehicleNo: this.checkVehicle.VehicleNo,
        NowGPS: this.checkVehicle.NowGPS,
      };

      let LineClassDayDepartureRecordJsonText = {
        LineClassDayGID: this.lineClassDay.GID,
        StartNodeGID: this.node.NodeGID,
        VehicleGID: this.checkVehicle.VehicleGID,
        VehicleInfo: JSON.stringify(VehicleInfo),
        OperType: OperType, //操作类型 1:签到发车 2:更新
        SignInType: SignInType, //签到类型 1:定位签到  2:拍照签到
        SignInImg: SignInType == 2 ? this.vehicleNoimgBase64 : null,
        StaffCount: this.staffCount,
        PassengerCount: this.passengerCount,
        SignInOperGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID,
        SignInOperCode: JSON.parse(window.localStorage.getItem("adminInfo"))
          .UserCode,
        SignInOperName: JSON.parse(window.localStorage.getItem("adminInfo"))
          .UserName,
        ModifyGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID,
        ModifyCode: JSON.parse(window.localStorage.getItem("adminInfo"))
          .UserCode,
        ModifyName: JSON.parse(window.localStorage.getItem("adminInfo"))
          .UserName,
        CheckImage: this.CheckImage,
      };
      let params = {
        _JsonText: JSON.stringify(LineClassDayDepartureRecordJsonText),
      };
      this.$http
        .post(
          this.$api.lineClassDayDepartureRecordNewSignInSave,
          this.$qs.stringify(params)
        )
        .then((res) => {
          if (res.success) {
            let info = "操作";
            switch (OperType) {
              case 1:
                info = "签到发车";
                break;
              case 2:
                info = "修改";
                break;
            }
            this.$toast.success(info + "成功");
            this.nodelog = res.data;
            //let flag1 = this.ticketInfoList[0].ClassCheckedTickets > 0;
            //let flag4 = this.lineClassDay.HandSellCount > 0; //this.$utils.getSysParams("ReportSaleOrCheck") === "1";
            // let flag2 =
            //   [1, 2, 4, 5].indexOf(
            //     parseInt(this.line.lineInfo.CustomMadeLevel)
            //   ) > -1;
            // let flag3 = true;
            let flag5 =
              [
                "7818B465-1616-45C8-8F04-85F7F4F3BF52",
                "BB4C65EC-C701-4FDB-89D7-3514A5E929BB",
                "0C30EF14-CC00-4363-9207-1948743EEA51",
                "1DBB25D3-4E42-4568-936A-9D9CDC40052E",
                "AE27C5A9-22BA-405E-9682-ED180BBCABF4",
                "A77DCF3F-DA8C-40B9-93B8-896ACD96E282",
              ].indexOf(this.line.lineInfo.GID.toUpperCase()) > -1;
            let flag6 = this.nodelog.LineIsUseSpecialSendCar;
            let flag7 = this.nodelog.IsClassLastNode;
            //开启了一键报备，在操作最后一个点发车时也同时报备
            if (!flag5 && (!flag6 || flag7)) {
              this.onContractReport();
            }
            if (!this.isFromDriver) {
              this.$router.push({
                path: "LineClassDay",
              });
            }
          }
        });
    },
    //站点检票情况查询
    onQueryNodeCheck() {
      let Nodeparams = {
        LineClassDayGID: this.lineClassDay.GID,
        NodeGID: this.node.NodeGID,
      };
      this.$http
        .post(this.$api.getStartNode, this.$qs.stringify(Nodeparams))
        .then((res) => {
          if (res.success) {
            this.ticketInfoList = res.data;
            this.GpsVerificationType = res.data[0].GpsVerificationType;
            //单车 默认检票人数为上车人数
            if (!this.isCanBack) {
              this.passengerCount = this.ticketInfoList[0].CheckedTickets;
            }
            if (this.nodelog && this.nodelog.PassengerCount) {
              this.passengerCount = this.nodelog.PassengerCount;
            }
            if (this.nodelog && this.nodelog.StaffCount) {
              this.staffCount = this.nodelog.StaffCount;
            }
          }
        });
    },
    //站点(班次)发车记录查询 将班次数据查询出来 方便后面的校验
    onQueryNodeVehicleLog() {
      let params = {
        LineClassDayGID: this.lineClassDay.GID,
        //StartNodeGID: this.node.NodeGID,
        //VehicleGID: this.checkVehicle.VehicleGID
      };
      this.$http
        .post(
          this.$api.getLineClassDayDepartureRecord,
          this.$qs.stringify(params)
        )
        .then((res) => {
          if (res.success) {
            this.classLog = [];
            this.sendPeople = 0;
            res.data.forEach((item) => {
              if (item.VehicleGID == this.checkVehicle.VehicleGID) {
                this.classLog.push(item);
              }
              if (item.StartNodeGID == this.node.NodeGID) {
                this.sendPeople += item.PassengerCount;
                if (item.VehicleGID == this.checkVehicle.VehicleGID) {
                  this.nodelog = item;
                }
              }
            });
            //if (!this.nodelog) {
            //不存在签到发车记录 直接签到
            //   this.onGetNodeGis();
            // }
            //this.nodelog.StartCarTime  ModifyTime
            if (
              this.checkVehicle.Driver1Tel &&
              this.nodelog &&
              (this.nodelog.StartCarTime ||
                (!this.nodelog.StartCarTime && !this.nodelog.SignInOperTime))
            ) {
              this.checkedDriver1 = true;
            }
            if (
              this.checkVehicle.Driver2Tel &&
              this.nodelog &&
              (this.nodelog.StartCarTime ||
                (!this.nodelog.StartCarTime && !this.nodelog.SignInOperTime))
            ) {
              this.checkedDriver2 = true;
            }
          }
        });
    },
    //车牌号图片校验
    onUploadImg: function (param) {
      this.$http
        .post(this.$api.NewLicensePlateOCR, this.$qs.stringify(param))
        .then((res) => {
          if (res.success) {
            console.log(res);
            this.OCRvehicleNo = res.data.VehicleNo;

            let checkNoList = res.data.VehicleNo.split("");
            //判断车牌号是否一致
            let countTrue = 0;
            this.checkVehicle.VehicleNo.split("").forEach((item) => {
              for (let i = 0; i < checkNoList.length; i++) {
                let stringNo = checkNoList[i];
                if (item == stringNo) {
                  countTrue++;
                  checkNoList.splice(i, 1);
                  break;
                }
              }
            });
            //this.checkVehicle.VehicleNo != this.OCRvehicleNo
            if (countTrue <= 5) {
              //测试 车牌号一致 签到
              if (
                location.hostname == "localhost" ||
                location.hostname == "192.168.137.1" ||
                location.hostname == "test.hd.class.busboss.cn"
              ) {
                this.vehicleNoimgBase64 = param.imgBase64;
                this.onSaveSignInLog(2, 1);
                return;
              }
              // this.vehicleNoimgBase64 = postParm.imgBase64;
              // this.onSaveSignInLog(2, 1);
              this.onSaveonSignInErrorRecord(
                2,
                param.imgBase64,
                "识别车牌号与所派车辆不一致,识别的车牌号为" + this.OCRvehicleNo,
                3
              );
            } else {
              //车牌号一致 签到
              this.vehicleNoimgBase64 = param.imgBase64;
              this.onSaveSignInLog(2, 1);
            }
          } else {
            this.onSaveonSignInErrorRecord(
              2,
              param.imgBase64,
              "识别车牌号失败",
              4
            );
            //识别失败 清空图片
            //this.$toast.fail("车牌号识别失败");
            this.vehicleImg = [];
            return;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //图片上传
    afterReadImg(file) {
      //仅回调显示选择的图片 不上传 在车辆签到操作时才将图片转换并上传
      // this.LineClassDayVehicleDriverList[this.index].CheckImgPath =
      //   file.content;
      var postParm = {};
      //console.log(file);
      // 大于1MB的jpeg和png图片都缩小像素上传
      if (/\/(?:jpeg|png)/i.test(file.file.type) && file.file.size > 1000000) {
        // 创建Canvas对象(画布)
        let canvas = document.createElement("canvas");
        // 获取对应的CanvasRenderingContext2D对象(画笔)
        let context = canvas.getContext("2d");
        // 创建新的图片对象
        let img = new Image();
        // 指定图片的DataURL(图片的base64编码数据)
        img.src = file.content;
        // 监听浏览器加载图片完成，然后进行进行绘制
        img.onload = () => {
          // 指定canvas画布大小，该大小为最后生成图片的大小
          canvas.width = 800;
          canvas.height = 600;
          /* drawImage画布绘制的方法。(0,0)表示以Canvas画布左上角为起点，400，300是将图片按给定的像素进行缩小。
        如果不指定缩小的像素图片将以图片原始大小进行绘制，图片像素如果大于画布将会从左上角开始按画布大小部分绘制图片，最后的图片就是张局部图。*/

          context.drawImage(img, 0, 0, 800, 600);
          // 将绘制完成的图片重新转化为base64编码，file.file.type为图片类型，0.92为默认压缩质量
          file.content = canvas.toDataURL(file.file.type, 0.92);

          // 最后将base64编码的图片保存，留待上传。
          postParm = {
            imgBase64: file.content,
          };
          this.vehicleImg.push(file);
          this.onUploadImg(postParm);
        };
      } else {
        // 最后将base64编码的图片保存，留待上传。
        postParm = {
          imgBase64: file.content,
        };
        this.vehicleImg.push(file);
        this.onUploadImg(postParm);
      }
    },
  },
  mounted: function () {
    //给图片上传模块修改name属性
    this.$refs.vehicleImginput.setAttribute("name", "车牌拍照");
    var that = this;
    var fun = function (jsonObj) {
      this.endTimer();
      //定位失败
      if (!jsonObj.success) {
        that.$toast.fail("获取手持机定位失败!");
        return;
      }
      let position = {
        coords: {
          latitude: jsonObj.data.latitude,
          longitude: jsonObj.data.longitude,
        },
      };
      that.onGetGPSSuccess(position);
    };
    // 定位回调
    window.callGeolocation = fun.bind(this);

    // 设置wx.config
    if (this.$utils.getIsWxClient()) {
      this.$utils
        .setWXConfig()
        .then((res) => {
          //alert(JSON.stringify(res))
        })
        .catch((err) => {
          alert(JSON.stringify(err));
        });
    }
  },
  created() {
    window._AMapSecurityConfig = {
      securityJsCode: 'c6bcd7dc52ae28e9567c690ba7939b72'
    }
    AMapLoader.load({
      "key": "24f21e97ad61f5d65b50a38c175b3fe4",// 申请好的Web端开发者Key，首次调用 load 时必填
      "version": "2.0",   // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
    }).then((AMap) => {

    }).catch((e) => {
      console.error(e);  //加载错误提示
    });

    // window._AMapSecurityConfig = {
    //   securityJsCode: 'c6bcd7dc52ae28e9567c690ba7939b72',
    // }
    // var url =
    //   "https://webapi.amap.com/maps?v=1.4.12&key=24f21e97ad61f5d65b50a38c175b3fe4";
    // var jsapi = document.createElement("script");
    // jsapi.charset = "utf-8";
    // jsapi.src = url;
    // document.head.appendChild(jsapi);

    //this.onQueryLineClassDayVehicleDriver();
    this.onQueryNodeVehicleLog();
    this.onQueryNodeCheck();
    var ua = navigator.userAgent.toLowerCase();
    this.isWx = ua.indexOf("micromessenger") != -1;
  },
};
</script>

<style scoped lang="less">
.uploadBox>.uploadIcon {
  // 安检情况--上传照片
  position: relative;
  top: 0.0625rem;
  margin-left: 0.3125rem;
}

.btnColorOrange {
  background-color: orange;
}

.btnColorGreen {
  background-color: #07c160;
}

[v-cloak] {
  display: none !important;
}

.vehicleDiv {
  background-color: white;
  height: 2.7rem;
}

.vehicleDiv .info {
  float: left;
  width: 60%;
}

.vehicleDiv .info .vehicleno {
  position: relative;
  top: 0.3rem;
  font-weight: 800;
  font-size: 0.45rem;
  left: 0.3rem;
}

.vehicleDiv .info .cnospan {
  color: orangered;
  padding-left: 0.3rem;
  padding-right: 0.3rem;
}

.vehicleDiv .info .vehicleBtn {
  position: relative;
  top: 0.7rem;
  left: 0.3rem;
}

.vehicleDiv .info .vehicleBtn .signbtn {
  position: relative;
  width: 40%;
  float: left;
}

.vehicleDiv .info .vehicleBtn .checkRadio {
  font-size: 0.4rem;
  position: relative;
  width: 100%;
  float: right;
  top: 0.05rem;
}

.vehicleDiv .img {
  float: right;
  width: 40%;
}

.vehicleDiv .dirverradio {
  float: left;
  width: 23%;
  height: 100%;
  border-right: 1px solid #acc0d8;
}

.vehicleDiv .dirverinfo {
  float: left;
  width: 30%;
  font-size: 0.4rem;
  font-weight: 500;
}

.link-top {
  width: 100%;
  height: 1px;
  border-top: solid #acc0d8 1px;
}

.link-right {
  width: 50px;
  height: 20%;
  border-right: solid #acc0d8 1px;
}

.LineClassPicker {
  font-size: 14px;
  width: 95%;
  margin: 10px auto;
  text-align: -webkit-auto;
}

.van-cell__value {
  color: black;
}

.van-cell {
  font-size: 14px;
  padding: 0.2rem 0.2rem;
  line-height: 0.5rem;
}

.van-cell__left-icon,
.van-cell__right-icon {
  line-height: 0.5rem;
}

.van-cell__label {
  font-size: 12px;
  color: #323233;
}

.footer {
  height: 2rem;
}
</style>
